<template>
  <b-container fluid>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <TablaEsteroides
        :items.sync="movimientoService.data"
        :fields.sync="movimientoService.fieldsTraspasoPorPaciente"
        :show-search="false"
    >
      <template v-slot:cell(pacienteOrigen)="{item}">
        {{ item.origen.nombrePaciente }}
      </template>
      <template v-slot:cell(estatus)="{item}">
        {{ item.origen.nombreStatus }}
      </template>
      <template v-slot:cell(pacienteDestino)="{item}">
        {{ item.destino.nombrePaciente }}
      </template>
      <template v-slot:cell(folio)="{item}">
        {{ item.origen.idMovimiento }}
      </template>
      <template v-slot:cell(area)="{item}">
        {{ item.origen.nombreArea }}
      </template>
      <template v-slot:cell(clinica)="{item}">
        {{ item.origen.nombreClinica }}
      </template>
      <template v-slot:cell(empleado)="{item}">
        {{ item.origen.nombreEmpleado }}
      </template>
      <template v-slot:cell(tipoMovimiento)="{item}">
        {{ item.origen.nombreTipoMovimiento }}
      </template>
      <template v-slot:cell(folioPolizaContableErp)="{item}">
        {{ movimientoService.formatters.string.validarObjetoVacio(item.origen.folioPolizaContableErp) }}
      </template>
      <template v-slot:cell(monto)="{item}">
        {{ item.origen.monto | moneda }}
      </template>
      <template v-slot:cell(detalle)="row">
        <b-button
            v-b-modal="'detalle-'+row.item.origen.idMovimiento"
            size="sm"
            variant="info"
        >
          <font-awesome-icon
              icon="eye"
          />
        </b-button>
        <b-modal ok-title="Aceptar"
                 cancel-title="Cerrar"
                 size="xl" :id="'detalle-'+row.item.origen.idMovimiento" title="Detalle del movimiento">
          <p class="my-4">
            <DetalleTraspaso :fields="movimientoService.fieldsMovimientoDetalle" :traspaso="row.item"/>
          </p>
        </b-modal>
      </template>
      <template v-slot:cell(saldoTotal)="{item}">
        {{ item.origen.saldoTotal | moneda }}
      </template>
      <template v-slot:cell(pdf)="row">
        <MostrarComprobanteTraspaso v-if="row.item.origen.fechaSolucion != null"
                                    :id-movimiento="row.item.destino.idMovimiento"/>
        <div v-else class="text-info">No se ha completado el proceso</div>
      </template>
      <template v-slot:cell(archivos)="row">
        <b-button v-b-modal="'archivos-'+row.item.origen.idMovimiento" size="sm">
          <font-awesome-icon icon="file"/>
        </b-button>
        <b-modal
            ok-title="Aceptar"
            cancel-title="Cerrar"
            size="lg"
            :id="'archivos-'+row.item.origen.idMovimiento" title="Archivos del movimiento">
          <p class="my-4">
            <ListarArchivos :show-delete="false" :archivos="row.item.origen.archivos"/>
          </p>
        </b-modal>
      </template>
    </TablaEsteroides>

  </b-container>
</template>

<script>
import TablaEsteroides from "@/components/tablaConEsteroides/TablaEsteroides";
import {MovimientoService} from "@/apiServices/movimiento/MovimientoService";
import DetalleTraspaso from "./DetalleTraspaso";
import ListarArchivos from "../../../components/archivos/ListarArchivos";
import MostrarComprobanteTraspaso from "./MostrarComprobanteTraspaso";

export default {
  name: "ListaTraspasosPorPaciente",
  components: {MostrarComprobanteTraspaso, ListarArchivos, DetalleTraspaso, TablaEsteroides},
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      fieldsDetalle: [],
      movimientoService: new MovimientoService(),
    }
  },
  methods: {
    usuarioAutorizaMovimiento(autorizaciones) {
      return !!autorizaciones.find(autorizacion => autorizacion.idEmpleado === this.$localStorageService.getIdEmpleado())
    },
    autorizacionesCompletas(autorizaciones) {
      return !autorizaciones.find(autorizacion => autorizacion.autorizado === false)
    }
  },
  async created() {
    this.debug = this.$localStorageService.getDebug();

    this.$root.$on('paciente', async (paciente) => {
      this.movimientoService.listarTraspasos({idPaciente: paciente.idPaciente});
    })

  },
  computed: {
    isLoading() {
      return this.movimientoService.loading;
    }
  }
}
</script>
